import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {postData} from "../../Utils/Server";
import Endpoints from "../../Constants/Endpoints";
import {useHistory} from "react-router-dom";
import {updateDocumentTitle} from "../../Utils/Common";
import PageLayout from "../Layout/PageLayout";
import {Button, Card, DataTable, StatusBadge} from "../UI";

const CountryList = props => {
    let history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [list, setList] = useState([]);

    const columns = [
        {
            name: 'Name',
            selector: 'name',
            sortable: true,
            cell: row => <div><Link to={"/countries/" + row.id}>{row.name}</Link></div>,
        },
        {
            name: 'Code',
            selector: 'code',
            sortable: true,
        },
        {
            name: 'Currency',
            selector: 'currency',
            cell: row => <span>{row.currency}{row.currency_symbol ? ` (${row.currency_symbol})` : ''}</span>,
        },
        {
            name: 'Dial',
            selector: 'dial_code',
            cell: row => <span>{row.dial_code ? `+${row.dial_code}` : '—'}</span>,
        },
        {
            name: 'M-Pesa',
            selector: 'mpesa_enabled',
            cell: row => <StatusBadge tone={row.mpesa_enabled ? "success" : "neutral"}>{row.mpesa_enabled ? "Enabled" : "Disabled"}</StatusBadge>,
        },
        {
            name: 'PayStack',
            selector: 'paystack_account',
        },
        {
            name: 'Status',
            selector: 'status',
            cell: row => <StatusBadge tone={row.status === 1 ? "success" : "neutral"}>{row.status === 1 ? "Active" : "Inactive"}</StatusBadge>,
        },
    ];

    const load = () => {
        setIsLoading(true);
        postData(Endpoints.COUNTRY_LIST, new FormData())
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1 && Array.isArray(res.data)) {
                    setList(res.data);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error);
            });
    };

    useEffect(() => {
        updateDocumentTitle("Countries");
        load();
    }, []);

    return (
        <PageLayout
            title="Countries"
            actions={
                <Link to="/countries/new">
                    <Button>Add new country</Button>
                </Link>
            }
        >
            <Card padded={false}>
                <DataTable
                    columns={columns}
                    data={list}
                    progressPending={isLoading}
                    pointerOnHover={true}
                    noHeader={true}
                    onRowClicked={e => {
                        history.push('/countries/' + e.id);
                    }}
                />
            </Card>
        </PageLayout>
    );
};

export default CountryList;
